/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PropertyMatrixConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `PropertyMatrixApiModule.forRoot()`
 */
export interface PropertyMatrixConfigurationParams {
  rootUrl?: string;
}
